import dayjs from 'dayjs';
const TIME_STRING_FORMAT = 'HH:mm';
export const toDate = (timeString) => dayjs.utc(timeString, TIME_STRING_FORMAT);
export const fromDate = (date) => date.utc().format(TIME_STRING_FORMAT);
//# sourceMappingURL=TimeString.js.map